import {
    ABOUTUS_ERROR,
    ABOUTUS_UPDATED,
   LOADING_ON_ABOUTUS_SUBMIT,
    LOADING_ABOUTUS_DATA,
    GET_ABOUTUS
  } from "actions/types";
  
  const initialState = {
    currentAboutUs: null,
    loadingAboutUs: true,
    error: {},
  };
  
  export default function Index(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case ABOUTUS_ERROR:
        return {
          ...state,
          error: payload,
          loadingAboutUs: false,
        };
      case GET_ABOUTUS:
        return {
          ...state,
          currentAboutUs: payload,
          loadingAboutUs: false,
        };
      case LOADING_ABOUTUS_DATA:
        return {
          ...state,
          loadingAboutUs: true,
        };
      case LOADING_ON_ABOUTUS_SUBMIT:
        return {
          ...state,
          loadingAboutUs: true,
        };
      case ABOUTUS_UPDATED:
        return{
          ...state,
          loadingAboutUs: false,
        }
      default:
        return state;
    }
  }
  